'use client';
import dynamic from 'next/dynamic';

import Header from './Header';
const Sidebar = dynamic(() => import('./Sidebar'), { ssr: false });
// const Header = dynamic(() => import('./Header'), {ssr:false})
import { useEffect } from 'react';
import { seo } from '@/utils/seo';

const FullLayout = ({ children }) => {
  useEffect(() => {
    if (!window.location.pathname.includes('/info')) {
      seo(window.location.pathname);
    }
  }, []);

  const hideMobilemenu = () => {
    document.getElementById('sidebarArea').classList.remove('showSidebar');
  };

  return (
    <main>
      <div className="pageWrapper d-lg-flex">
        {/********Sidebar**********/}
        <aside className="sidebarArea shadow" id="sidebarArea">
          <Sidebar />
        </aside>

        {/********Content Area**********/}
        <div className="contentArea">
          {/********header**********/}
          <Header />
          {/********Middle Content**********/}
          <div
            className="container"
            style={{ minHeight: '100vh' }}
            onClick={() => {
              hideMobilemenu();
            }}
          >
            {children}
          </div>
        </div>
      </div>
    </main>
  );
};

export default FullLayout;
